module.exports = __webpack_public_path__ + "static/media/Rockruff.0c24d062.png";